import type { AsyncNamespaceInput } from "./namespace/namespace.types.js";
import type { QueuableFunction } from "./function/function.types.js";
import type {
  NexusSignalDefinition,
  NexusEventListener,
  StartStopNotifier,
} from "./event/event.types.js";
import type { AnyFunction } from "./utils/utils.types.js";

/**
 *
 *
 *
 *
 *
 *
 */
export function defineNamespace<T>(implementation: AsyncNamespaceInput<T>): AsyncNamespaceInput<T> {
  return { ...implementation, [Symbol.onexus.namespace]: true } as never;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function defineFunction<Handler extends AnyFunction>(
  handler: Handler,
): QueuableFunction<Handler> {
  return handler as never;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function defineEvent<T = void>(
  ...listeners: NexusEventListener<T>[]
): NexusSignalDefinition<T> {
  return { [Symbol.onexus.event]: { listeners } } as NexusSignalDefinition<T>;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function defineStore<T = void>(
  detail?: T,
  start?: StartStopNotifier<T>,
): NexusSignalDefinition<T> {
  return { [Symbol.onexus.event]: { detail, start } } as NexusSignalDefinition<T>;
}
